<div class="flex flex-col flex-1 gap-2">
  <dx-form
    #formCodiceFiscaleHelper
    [formData]="codiceFiscaleHelperData"
    labelLocation="top"
    [showColonAfterLabel]="false"
    (onFieldDataChanged)="onFieldDataChanged()"
  >
    <dxi-item
      dataField="nome"
      [label]="{
        text: 'Nome' | transloco
      }"
      editorType="dxTextBox"
      [editorOptions]="{
        valueChangeEvent: 'keyup'
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="cognome"
      [label]="{
        text: 'Cognome' | transloco
      }"
      editorType="dxTextBox"
      [editorOptions]="{
        valueChangeEvent: 'keyup'
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="sesso"
      [label]="{
        text: 'Sesso' | transloco
      }"
      editorType="dxSelectBox"
      [editorOptions]="{
        displayExpr: 'display',
        valueExpr: 'value',
        dataSource: [
          { value: 'male', display: 'Maschile' | transloco },
          { value: 'female', display: 'Femminile' | transloco }
        ],
        dropDownOptions: dropDownOptions
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="dataDiNascita"
      [label]="{
        text: 'Data di nascita' | transloco
      }"
      editorType="dxDateBox"
      [editorOptions]="{
        max: now,
        dropDownOptions: dropDownOptions
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="codiceCatastale"
      [label]="{
        text: 'Comune di nascita' | transloco
      }"
      editorType="dxSelectBox"
      [editorOptions]="{
        dataSource: codiceFiscaleComuniDataSource,
        searchEnabled: true,
        valueExpr: 'codiceCatastale',
        displayExpr: 'comune',
        dropDownOptions: dropDownOptions
      }"
    >
    </dxi-item>
  </dx-form>
</div>
